// extracted by mini-css-extract-plugin
var _1 = "v4iGl";
var _2 = "BOfVo";
export { _1 as "base", _2 as "details" }
